import { Component, Input } from "@angular/core";
import { Team } from "@common/ADAPT.Common.Model/organisation/team";
import { TeamSupplementaryData } from "@common/ADAPT.Common.Model/organisation/team-supplementary-data";
import { RxjsBreezeService } from "@common/lib/data/rxjs-breeze.service";
import { BaseComponent } from "@common/ux/base.component/base.component";
import { AuthorisationService } from "@org-common/lib/authorisation/authorisation.service";
import { CommonTeamsService } from "@org-common/lib/teams/common-teams.service";
import { CommonTeamsAuthService } from "@org-common/lib/teams/common-teams-auth.service";
import { combineLatest, Observable, ReplaySubject } from "rxjs";
import { startWith, switchMap } from "rxjs/operators";
import { CommonTeamsUiService } from "../common-teams-ui.service";

@Component({
    selector: "adapt-team-accountabilities-dashboard-element",
    templateUrl: "./team-accountabilities-dashboard-element.component.html",
    standalone: false,
})
export class TeamAccountabilitiesDashboardElementComponent extends BaseComponent {
    public readonly ConfigureTeam = CommonTeamsAuthService.ConfigureTeam;

    @Input() public embedded = false;
    @Input() public set team(value: Team) {
        this.team$.next(value);
    }

    public team$ = new ReplaySubject<Team>(1);
    public teamSupplementaryData$: Observable<TeamSupplementaryData | undefined>;
    public canEditTeamAccountabilities$: Observable<boolean>;

    public constructor(
        authorisationService: AuthorisationService,
        rxjsBreezeService: RxjsBreezeService,
        private commonTeamsService: CommonTeamsService,
        private commonTeamsUiService: CommonTeamsUiService,
    ) {
        super();

        const entityChange$ = rxjsBreezeService.entityTypeChangedInSave(TeamSupplementaryData).pipe(
            startWith(undefined),
        );

        this.teamSupplementaryData$ = combineLatest([this.team$, entityChange$]).pipe(
            switchMap(([team]) => this.commonTeamsService.getTeamSupplementaryData(team)),
        );

        this.canEditTeamAccountabilities$ = this.team$.pipe(
            switchMap((team) => authorisationService.promiseToGetHasAccess(CommonTeamsAuthService.ConfigureTeam, team)),
        );
    }

    public editTeamAccountabilities() {
        return this.team$.pipe(
            switchMap((team) => this.commonTeamsUiService.configureTeamAccountabilities(team!)),
        ).subscribe();
    }
}
